import { selectFeesResponse } from '../../redux-state/selectors';
import { useSelector } from 'react-redux';

function OutputRightSide({ downloadAble }) {
  const response = useSelector(selectFeesResponse);

  const keys = Object.keys(response);
  const printableKeys = keys.filter((key) => !["Inputs", "Notes", "Type", "TransactionID"].includes(key));
  let index = 0;
  let dynamicFields = [];

  for (let i = 0; i < printableKeys.length/2; i++) {
    dynamicFields.push(
      <div className='flex flex-col w-full min-w-0 text-gray-700 gap-2'>
        <div className='flex flex-row justify-between gap-2 items-start'>
          <div>
            {printableKeys[index]}
          </div>
          <div className='font-medium text-right break-words min-w-0'>
            {response[printableKeys[index]]}
          </div>
        </div>

        <div className='flex flex-row justify-between gap-2 items-start'>
          <div>
            {printableKeys[index+1]}
          </div>
          <div className='font-medium text-right break-words min-w-0'>
            {response[printableKeys[index+1]]}
          </div>
        </div>
      </div>
    )
    index += 2;
  }

  function replaceLinksWithTextAndHref(html) {
    return html.replace(/<a[^>]*href="([^"]+)"[^>]*>(.*?)<\/a>/g, '$2 ($1)');
  }

  return (
    <div className='flex flex-col w-[100%]'>
      <div className='flex flex-col gap-4 w-[100%]'>
        <div className='flex flex-row justify-between mb-4 items-center'>
          <div className='text-gray-700 font-bold'>
            Fees Output
          </div>
        </div>
      </div>

      <div className='bg-white p-6 rounded-xl text-sm mb-4 mt-4 border border-gray-300'>
        <div className='text-gray-700 mb-3 font-medium'>
          Fee Output
        </div>

        <div className='flex flex-col lg:flex-row w-full gap-6 lg:gap-8 mb-2'>
          {dynamicFields}
        </div>

        <div className='flex flex-col w-full min-w-0 text-gray-700 gap-2'>
          {response["TransactionID"] &&
            <div className='flex flex-col sm:flex-row justify-between break-words gap-1'>
              <div>
                Transaction ID:
              </div>
              <div className='font-medium max-w-full break-all text-right sm:text-left'>
                {response["TransactionID"]}
              </div>
            </div>
          }
        </div>
      </div>

      {response["Notes"] && response["Notes"] !== "" &&
        <div className='bg-white p-6 rounded-xl text-sm border border-gray-300'>
          <div className='mb-2 text-gray-700'>
            Notes
          </div>
          <ul className="list-disc pl-6 space-y-2 text-gray-600 text-xs">
            {response["Notes"].split('|').map((note, key) => (
              <li
                key={key}
                className='sanitizedHtml'
                dangerouslySetInnerHTML={{
                  __html: downloadAble
                    ? replaceLinksWithTextAndHref(note)
                    : note.replaceAll('<a ', '<a target="_blank" ')
                }}
              />
            ))}
          </ul>
        </div>
        }
    </div>
  )
}

export default OutputRightSide;